import { Component, Input } from '@angular/core'
import { SeMenuService } from './menu.service'
import { SePositioningService,
         SePositionedObject,
         SePositioningServiceOptions } from '../positioning-service/positioning.service'
import UuidUtility from '../core/uuid-utility'

export interface SeMenuSection {
  header?: string
  divider?: boolean
  menuItems: SeMenuItem[]
}

export interface SeMenuItem {
  text: string
  subText?: string
  icon?: string
  disabled?: boolean
  action?: () => void
  href?: string
  uiSref?: string
  gotoContext?: string
  routerLink?: string
  target?: string
}

export interface SeMenuOptions {
  sections: SeMenuSection[]
}

@Component({
  standalone: false,
  selector: 'se-menu',
  templateUrl: './menu.component.html',
})
export class SeMenuComponent {

  public iconName: string
  public contentId: string
  public maxHeightStyle: any
  public show: boolean = false
  public isDragging: boolean = false
  private positionedMenu: SePositionedObject
  private menuOptions: SePositioningServiceOptions

  @Input('se-data-reference-id') referenceId: string
  @Input('se-data-container-id') containerId: string
  @Input('se-data-max-height') maxHeight: string
  @Input('se-data-options') options: SeMenuOptions

  constructor(
    private menuService: SeMenuService,
    private positioningService: SePositioningService,
    ) {
    // noop
  }

  public ngOnInit(): void {
    this.initialize()
  }

  public ngOnChanges(): void {
    this.initialize()
  }

  public ngOnDestroy(): void {
    if (this.positionedMenu) {
      this.destroyPositionedMenu()
    }
    this.menuService.unregister(this)
  }

  public initialize(): void {
    this.initContentUuid()
    this.menuService.unregister(this)
    this.menuService.register(this)
    if (!!this.positioningService.defaultOptions) {
      this.menuOptions = this.positioningService.defaultOptions
      this.menuOptions.placement = 'bottom-start'
      const flipModifier  = this.menuOptions.modifiers.find(modifier => modifier.name === 'flip')
      flipModifier.options.allowedAutoPlacements = ['bottom', 'top']
      this.menuOptions.strategy = 'fixed'
    }
    if (this.maxHeight) this.maxHeightStyle = {'max-height': `${this.maxHeight}px`}
  }

  public get menuClass(): string {
    return this.show ? 'se-menu--visible' : 'se-menu--hidden'
  }

  public destroyPositionedMenu(): void {
    this.positionedMenu.destroy()
    this.positionedMenu = undefined
  }

  public initContentUuid(): void {
    this.contentId = UuidUtility.getUuid()
  }

  public positionMenuContent(): void {
    if (!this.positionedMenu && this.referenceId && this.contentId) {
      this.positionedMenu = this.positioningService.create(this.referenceId,
                                                         this.contentId,
                                                         this.containerId,
                                                         this.menuOptions)
    }

    if (this.positionedMenu) {
      // timeout ensures element is show to position correctly
      setTimeout(() => this.positionedMenu && this.positionedMenu.update())
    }
  }

  public onTouchEnd(): void {
    if (this.isDragging) {
      this.isDragging = false
    } else {
      this.show = false
    }
  }

  public onTouchMove(): void {
    this.isDragging = true
  }

  public onClick(): void {
    if (this.show) {
      this.show = false
    } else {
      this.positionMenuContent()
      this.show = true
    }
  }

  public onClickOff(): void {
    this.show = false
  }

  public getItemClass(menuItem: SeMenuItem, section: SeMenuSection): string {
    let outputClass = ''
    if ( menuItem.disabled === true ) outputClass += ' se-menu-item--disabled'
    if ( !!section.header ) outputClass += ' se-menu-item--has-header'
    if ( !!menuItem.icon ) outputClass += ' se-menu-item--has-icon'

    return outputClass
  }

}
